import React from 'react';
import {ICRSOutline} from "../interfaces";
import {getJSONFromHtml} from "../../../../domain/common";

/**
 * the entry point
 */
const ProductMoreCourses = () => {


        const moreCourses = getJSONFromHtml(document.getElementById('product-page-more-courses-data')) as ICRSOutline[];
        if(!moreCourses)
            return <></>;


        return(
            <div className="flex flex-wrap flex-col justify-start w-full py-20">
                More Courses React {moreCourses.length}
            </div>

        );

};

export default ProductMoreCourses;